import { FaqItem, FaqList, FaqListResponse } from "@models/graphQL";

export class FaqMapper {
  public static calculateFaqItems(faqList: FaqList) : FaqListResponse {
    if (!faqList) {
      return
    }

    const response = new FaqListResponse;
    response.title = faqList.title;
    response.link = faqList.link;

    var faqItems, faqItemsFromCategories:FaqItem[];
    faqItems = faqList.faqItems?.targetItems ?? [];

    faqItemsFromCategories = [];
    if (faqList.faqCategories?.targetItems) {
      faqList.faqCategories.targetItems.forEach(cat => {
        if (cat.children) {
          faqItemsFromCategories = faqItemsFromCategories.concat(cat.children);
        }
      });

      if (faqList.maxFaqItemsFromCategories) {
        faqItemsFromCategories = faqItemsFromCategories.slice(0, faqList.maxFaqItemsFromCategories.numberValue);
      }
    }

    response.faqItems = (faqList.faqCategoriesLast && faqList.faqCategoriesLast.boolValue) ?
      faqItems.concat(faqItemsFromCategories) :
      faqItemsFromCategories.concat(faqItems);

    return response;
  }
}